import {APIRequestConfig} from "@buildwitt/shapeshift-common/types/ICommon";
import {APIState, useApi} from "@buildwitt/shapeshift-identity";
import {IModuleEnrollment} from "@buildwitt/shapeshift-types";

type S = IModuleEnrollment;
type R = string;
type G = (announcementSlug: string, config?: APIRequestConfig<R>) => void;

export type IUseSetAnnouncementCompletionReturnProp = {
	response?: S,
	apiResult: APIState<S>,
	setComplete: G
}

export const useSetAnnouncementCompletion = (): IUseSetAnnouncementCompletionReturnProp => {
	const [apiResult, getData] = useApi<S>(null);

	const setComplete: G = (announcementSlug, config) =>
		getData({
			...(config ?? {}),
			url: "/api/announcement/learn/" + announcementSlug + "/complete" ,
			method: "PUT",
			cache: false
		});

	return {response: apiResult.data, apiResult, setComplete};
}